module.exports = __webpack_public_path__ + "img/travel.5ea0196f.webp";